import * as React from 'react';

export interface IDxgMenuDetailsUIStateProps {
    menuProductsList: IDxgMenuDetailsUIMenuProductsList[];
}

export interface IDxgMenuDetailsUIMenuProductsList {
    name: string;
    price: number;
}

const DxgMenuDetailsUI: React.FC<IDxgMenuDetailsUIStateProps> = (props) => {
    const getMappedMenuProducts = (menuProductsList: IDxgMenuDetailsUIMenuProductsList[]) => {
        const mappedMenuProducts = menuProductsList.map((menuProducts) => {
            return (
                <li data-testId='card-drawer-content' key={menuProducts.name}>
                    <span data-testId='card-drawer-list-name'>{menuProducts.name}:{' '}</span>
                    <span className='card-drawer-list-values'>${menuProducts.price}</span>
                </li>
            );
        });

        return mappedMenuProducts;
    };

    return (
        <div className='card-drawer-details'>
            <h3>Vehicle Protection Details</h3>
            <ul className='card-drawer-list'>
                {getMappedMenuProducts(props.menuProductsList)}
            </ul>
        </div>
        );
};

export default DxgMenuDetailsUI;
